import React from "react";
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  // const hasAuthenticated = isAuthenticated();
  // console.log("hasAuthenticated", hasAuthenticated);
  return <>{children}</>;
}
